<template>
    <div class="routing-list">
        <h1 class="view-title" data-v-step-routing-list="1">
			ROTEIROS <span v-popover:tooltip.right="'Seção de gerenciamento dos Roteiros de entrega'"><i class="fas fa-question-circle"></i></span>
            <a class="btn btn-link btn-right" :href="root_url + '/download/deliveryb2b_help.pdf'" target="_blank" data-v-step-routing-list="2">
                <i class="fas fa-file-pdf"></i> ABRIR TUTORIAL
            </a>
		</h1>
        <div class="inner-content shadowed">
            <div class="inner-content-title">
				Lista <span v-popover:tooltip.right="'Lista dos roteiros gerados'"><i class="fas fa-question-circle"></i></span>
				<button class="add_new_routing" :disabled="loading" @click="changeView" data-v-step-routing-list="4">
					<i class="fas" :class="loading ? 'fa-circle-notch fa-spin': 'fa-plus'"></i> NOVO ROTEIRO
				</button>
                <button class="btn btn-link btn-right" @click="$refs.tour.editTour()" data-v-step-routing-list="3" style="margin-top: 10px; margin-left: 15px;">
                    <i class="fas fa-question-circle"></i> TOUR
                </button>
			</div>
            <div class="row">
				<div class="col-xs-12 col-lg-12">
                    <div class="search" data-v-step-routing-list="5">
                        <label>Filtro:</label>
                        <input type="text" v-model="search" @keydown.enter.prevent="load(true)" /> 
                    </div>
                    <Table 
                        :loading="loading"
                        :headers="headers" 
                        :ordering="ordering"
                        :order="order"
                        @reorder="(o) => { order = o; load(); }"
                        :list="list" 
                        :page="page"
                        :per_page="per_page" 
                        :total="total" 
                        :modifiers="modifiers"
                        @next="() => { page++; load(); }" 
                        @prev="() => { page--; load(); }"
                        v-slot="{item}"
                        data-v-step-routing-list="6"
                    >
                        <button class="button-edit" @click="showRoutes(item)" title="Ver roteiro">
                            <i class="fa fa-fw fa-route"></i> VER
                        </button>
                        <button class="button-edit" @click="showDownload(item)" title="Baixar roteiro">
                            <i class="fas fa-file-download"></i> BAIXAR
                        </button>
                        <button v-if="client_atak && item.finished" class="button-edit" @click="showSynchronizationAtak(item)" title="Sincronizar cargas com sistema integrado">
                            <i class="fas fa-sync"></i> SINCRONIZAR
                        </button>
                        <button v-if="item.finished" class="button-edit" @click="showReport(item)" title="Gerar relatório das cargas">
                            <i class="fas fa-file-invoice"></i> RELATÓRIO
                        </button>
                        <button class="button-remove" @click="remove(item.id)" title="Remover roteiro">
                            <i class="fa fa-fw fa-trash"></i> REMOVER
                        </button>
                    </Table>
                </div>
            </div>
        </div>

        <RoutingModalDownload v-if="showModalDownload"
            :current="current"
            :client_atak="client_atak"
            @download="downloadFile"
            @close="closeDownload"
        />
        
        <RoutingModalSynchronizationAtak v-if="showModalSynchronizationAtak"
            :current="current"
            :my_drivers="my_drivers"
            :my_courses="my_courses"
            :integration="my_settings.integration"
            :url_api_atak="my_settings.url_api_atak"
            :default_driver_code="my_settings.default_driver_code"
            :default_shipping_company_code="my_settings.default_shipping_company_code"
            @close="closeSynchronizationAtak"
        />

        <RoutingModalReportViewPDF v-if="showModalReportViewPDF"
            :current="current"
            @close="closeReportViewPDF"
            ref="report_view_pdf"
        />

        <Tour
            tour="DeliveryRouting"
            :steps="tour_steps"
            :callbackOnFinish="true"
			ref="tour"
        />
    </div>
</template>

<script>
import Api from "@/lib/Api";

import Table from "@/components/Table";
import Tour from "@/components/Tour";
import RoutingModalDownload from "../Routing/RoutingModalDownload";
import RoutingModalSynchronizationAtak from "./RoutingModalSynchronizationAtak";
import RoutingModalReportViewPDF from "./RoutingModalReportViewPDF";

export default {
    name: "RoutingList",

    components: {
        Table,
        Tour,
        RoutingModalDownload,
        RoutingModalSynchronizationAtak,
        RoutingModalReportViewPDF,
    },

    props: {
        my_drivers: {
            type: Array,
            require: true,
        },
        my_courses: {
            type: Array,
            require: true,
        },
        my_settings: {
            type: Object,
            require: true,
        },
    },

    data: function() {
        // Colunas exibidas conforme a empresa ser cliente atak
        let headers = {};
        if (this.$api.user.company_client_atak) {
            headers = {
                name: "Nome",
                date: "Embarque",
                finished: "Finalizado",
                cargo: "Carga",
                synchronized: "Sincronizado",
                total_route: "Rotas",
                total_delivery: "Entregas",
                total_distance: "Distância",
                total_weight: "Peso",
            };
            
        } else {
            headers = {
                name: "Nome",
                date: "Embarque",
                finished: "Finalizado",
                cargo: "Carga",
                total_route: "Rotas",
                total_delivery: "Entregas",
                total_distance: "Distância",
                total_weight: "Peso",
            };
        }

        return {
            root_url: this.$api.config.B2B_ROOT_URL,
            loading: false,
            search: "",
			headers: headers,
            ordering: ['name', 'date', 'cargo'],
            order: 'date-DESC',
            list: [],
            page: 0,
            per_page: 25,
            total: 0,
            
            modifiers: {
                date: function(d) {
                    let date = d.split("-").reverse().join("/");
                    return '<span title="' + date + '">' + date + '</span>';
                },

                finished: function(d) {
                    d = d ? "SIM" : "NÃO";
                    return '<span title="' + d + '">' + d + '</span>';
                },

                cargo: function(d) {
					let str = "";
					let color = "";
					if (d) { 
						str = d.toLowerCase();
					} else {
						str = "Não finalizado";
						color = "color: #aaa";
					}
                    return `<span class="capitalized" title="${str}" style="${color}">${str}</span>`;
                },
                
                synchronized: function(d) {
                    d = d ? "SIM" : "NÃO";
                    return '<span title="' + d + '">' + d + '</span>';
                },

				total_distance: function(d) {
                    d = !d ? 0: parseFloat(d);
                    let distanceFormated = "";
            
                    if(d < 1000)
                        distanceFormated = d.toFixed(1) + " m";
                    else
                        distanceFormated = (d / 1000).toFixed(1) + " km";
                        
                    distanceFormated = distanceFormated.replace(".", ",");

					return '<span title="' + distanceFormated + '">' + distanceFormated + '</span>';
				},

				total_weight: function(d) {
                    d = !d ? 0 : parseFloat(d);

                    let weightFormated = "";

                    if(d < 1000)
                        weightFormated = d.toFixed(2) + " kg";
                    else
                        weightFormated = (d / 1000).toFixed(2) + " t";
                        
                    weightFormated = weightFormated.replace(".", ",");

                    return "<span title='" + weightFormated + "'>" + weightFormated + "</span>";
				},

                constraints: function(d, item) {
                    let weight = "<span title='" + (item.weight_constraint ? 'Ligado' : 'Desligado') + "'><i class='" + (item.weight_constraint ? 'fas fa-fw fa-check-square' : 'far fa-fw fa-square') + "'></i> Peso</span>";
                    let time = "<span title='" + (item.time_constraints ? 'Ligado' : 'Desligado') + "'><i class='" + (item.time_constraint ? 'fas fa-fw fa-check-square' : 'far fa-fw fa-square') + "'></i> Tempo</span>";
                    return weight + " " + time;
                }
			},
            
            current: null,
            showModalDownload: false,
            showModalSynchronizationAtak: false,
            showModalReportViewPDF: false,

            client_atak: this.$api.user.company_client_atak,
            
            tour_steps: [
                {
                    target: '[data-v-step-routing-list="0"]',
                    header: {
                        title: '<code>SEÇÃO ROTEIRIZAÇÃO</code>',
                    },
                    content: '<code>Clique no menu <b>ROTEIRIZAÇÃO</b> para ir a seção criação e visualização do roteiros</code>',
                    params: {
                        placement: 'right',
                        highlight: false,
                    }
                },
                {
                    target: '[data-v-step-routing-list="1"]',
                    header: {
                        title: '<code>SEÇÃO ATUAL</code>',
                    },
                    content: '<code>Identifique pelo título a seção que está atualmente</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-list="2"]',
                    header: {
                        title: '<code>TUTORIAL</code>',
                    },
                    content: '<code>Clique no botão <b>ABRIR TUTORIAL</b> para visualizar o documento PDF de ajuda com dicas e explicações dos passos necessários para roteirização</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-list="3"]',
                    header: {
                        title: '<code>TOUR</code>',
                    },
                    content: '<code>Em caso de dúvida clique no botão <b>TOUR</b> para gerenciar a exibição do tour nessa seção, e assim ter um auxílio referente aos elementos da página</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-list="4"]',
                    header: {
                        title: '<code>NOVO ROTEIRO</code>',
                    },
                    content: '<code>Clique no botão <b>NOVO ROTEIRO</b> para avançar as etapas de criação de roteiro</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-list="5"]',
                    header: {
                        title: '<code>FILTRAGEM</code>',
                    },
                    content: '<code>Campo de filtragem dos roteiros</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-list="6"]',
                    header: {
                        title: '<code>ROTEIROS</code>',
                    },
                    content: '<code>Lista dos registros de roteiros cadastrados</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ],
        }
    },
    
    mounted: function() {
        this.$refs.tour.setTour();
        this.load();
    },
    
    methods: {
        /**
         * Requisita a lista
         */
		load: async function() {
            // Inicia o objeto das informações
            let form = {};
            
            // Verifica se houve uma busca
            if (this.search) form.search = this.search;
            form.page = this.page;
            form.per_page = this.per_page;
            
            // Verifica a ordenação
            if (this.order) form.order = this.order;
            
            // Reinicia as informações gerais
			this.list = [];
			this.total = 0;
            
            // Requisita as informações
            this.loading = true;
            let result = null;
            try {
                result = await Api.post("delivery-routing/list", form);
            } catch(ex) {
                console.log(ex);
                this.loading = false;
                this.$notification.error("Não foi possível recuperar o roteiro.");
                return;
            }
            this.loading = false;

            if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.list = result.data;
					this.total = result.total;
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter a lista.");
				return;
			}
		},

        /**
         * Exibe o mapa com as rota do roteiro selecionado
         * @param {object} item objeto com informações do roteiro
         */
        showRoutes: async function(item) {
            // Verifica se o registro foi passado corretamente
            if(typeof item.id === "undefined") {
                this.$notification.error("Não foi possível identificar o roteiro.");
				return;
            }
            
            // Inicia as variáveis necessárias
            let result = null;
            try {
                // Requisita as informações
                result = await Api.post("delivery-routing/get-delivery-routing", {
                    id: item.id,
                });
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter as informações do roteiro.");
                return;
            }

			if(result) {
                // Verifica se houve erro
                if(result.error) {
                    if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
                        this.$notification.error(result.data);
                        return;
                    }
                } else {
                    // Com sucesso, retorna as informações
                    let delivery = result.data;
                    let date = new Date(delivery.base.date);

                    delivery.base.date = date;
                    
                    this.$emit("update", delivery);
                    this.$emit("view", "map");
                    return;
                }
            } else {
                this.$notification.error("Não foi possível obter as informações do roteiro.");
                return;
            }
        },

        /**
         * Exibe o modal de download do roteiro selecionado
         * @param {object} item objeto com informações do roteiro atual
         */
        showDownload: function(item) {
            this.current = item;
            this.showModalDownload = true;
        },

        /**
         * Gera o arquivo de dados do roteiro na forma selecionada
         * @param {boolean} selection boleano que identifica o tipo de arquivo será exportado
         */
        downloadFile: async function(selection) {
            // Inicia as variáveis necessárias
            let result = null;
            
            // Verifica a seleção
            if (selection) {
                try {
                    result = await Api.post("delivery-routing/download-txt", {
                        id: this.current.id,
                        client_atak: this.client_atak,
                    });
                } catch (ex) {
                    console.log(ex);
                    this.$notification.error("Não foi possível obter o roteiro.");
                    return;
                }
                
                // Verifrica se foi processado
                if(result) {
                    if(result.error) {
                        if (result.data == "unauthorized") {
                            this.$notification.error("Desculpe, sua sessão expirou.");
                            setTimeout(() => { 
                                Api.logout();
                                return;
                            }, 2000);
                        } else {
                            this.$notification.error(result.data);
                            return;
                        }
                    } else {
                        // Verifica se houve erro            
                        let txt = result.data.txt;   
                        let name = result.data.name;

                        this.downloadTXT(txt, name);
                        return;
                    }
                } else {
                    this.$notification.error("Não foi possível exportar o roteiro.");
                    return;
                }
            } else {
                try {
                    result = await Api.post("delivery-routing/download-csv", {
                        id: this.current.id,
                    });
                } catch (ex) {
                    console.log(ex);
                    this.$notification.error("Não foi possível obter o roteiro.");
                    return;
                }
                
                // Verifrica se foi processado
                if(result) {
                    if(result.error) {
                        if (result.data == "unauthorized") {
                            this.$notification.error("Desculpe, sua sessão expirou.");
                            setTimeout(() => { 
                                Api.logout();
                                return;
                            }, 2000);
                        } else {
                            this.$notification.error(result.data);
                            return;
                        }
                    } else {
                        // Verifica se houve erro            
                        let csv = result.data.csv;   
                        let name = result.data.name;

                        this.downloadCSV(csv, name);
                        return;
                    }
                } else {
                    this.$notification.error("Não foi possível exportar o roteiro.");
                    return;
                }
            }
        },
        
        /**
         * Prepara o arquivo de exportação csv
         * @param {array} arrayData array com as informações do arquivo
         * @param {string} name string do nome do arquivo
         */
        downloadCSV: function(arrayData, name) {
            if(arrayData) {
                var encodedUri = encodeURI(arrayData);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", name + '.csv');
                document.body.appendChild(link); // Required for FF
    
                link.click(); // This will download the data file named "my_data.csv".
            }
        },
        
        /**
         * Prepara o arquivo de exportação txt
         * @param {array} arrayData array de informações
         * @param {String} name nome do arquivo
         */
        downloadTXT: function(arrayData, name) {
            if(arrayData) {
                var encodedUri = encodeURI(arrayData);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", name + '.txt');
                document.body.appendChild(link); // Required for FF
    
                link.click(); // This will download the data file named "my_data.txt".
            }
        },

        /**
         * Limpa as informações sobre o roteiro selecionado
         */
        closeDownload: function() {
            this.showModalDownload = false;
            this.current = null;
        },
        
        /**
         * Exibe o modal de exportação do roteiro selecionado
         * @param {object} item objeto com informações do roteiro atual
         */
        showSynchronizationAtak: function(item) {
            this.current = item;
            this.showModalSynchronizationAtak = true;
        },

        /**
         * Limpa as informações sobre o roteiro selecionado
         */
        closeSynchronizationAtak: function() {
            this.showModalSynchronizationAtak = false;
            this.current = null;
        },

        /**
         * Gera o relatório da carga do roteiro selecionado
         * @param {object} item objeto com informações do roteiro
         */
         showReport: async function(item) {
            // Verifica se o registro foi passado corretamente
            if(typeof item.id === "undefined") {
                this.$notification.error("Não foi possível identificar o roteiro.");
				return;
            }
            
            // Inicia as variáveis necessárias
            let result = null;
            try {
                // Requisita as informações
                result = await Api.post("delivery-routing/get-delivery-routing-report", {
                    id: item.id,
                });
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter as informações do roteiro.");
                return;
            }

			if(result) {
                // Verifica se houve erro
                if(result.error) {
                    if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
                        this.$notification.error(result.data);
                        return;
                    }
                } else {
                    // Com sucesso, retorna as informações
                    this.current = result.data;
                    this.showModalReportViewPDF = true;
                    return;
                }
            } else {
                this.$notification.error("Não foi possível obter as informações do roteiro.");
                return;
            }
        },

        /**
         * Limpa as informações sobre o roteiro selecionado
         */
        closeReportViewPDF: function() {
            this.showModalReportViewPDF = false;
            this.current = null;
        },
        

        /**
         * Remove o roteiro solicitado
         * @param {number} id id do roteiro
         */
        remove: async function(id) {
            // Apresenta a confirmação
            let confirm = await this.$alert.confirm("Deseja mesmo remover o roteiro?", "REMOVER");

            // Verifica se para remover
            if(!confirm) return;
            
            // Inicia as variáveis necessárias
            let result = null;

            // Requisita a remoção
            this.loading = true;
			try {
				result = await Api.post("delivery-routing/remove", {
                    id: id,
                });
			} catch (ex) {
				console.log(ex);
				this.loading = false;
				this.$notification.error("Não foi possível remove o roteiro.");
				return;
			}
            this.loading = false;
			
			if(result) {
				// Verifica se houve erro
				if(result.error) {
					this.$notification.error(result.data);
					return;
				} else {
					this.$notification.success("Roteiro removido com sucesso.");

					// Recarrega a lista
					this.load();
					return;
				}
			} else {
				this.$notification.error("Não foi possível fazer a remoção.");
				return;
			}
        },

        /**
         * Muda a view para o form de roteiro
         */
        changeView: function() {
            this.$emit('view', 'form');
        },
    }
}
</script>

<style scoped>
.add_new_routing {
	float: right;
	margin-top: 10px;
	border: none;
	background: #d9d9d9;
	color: #000;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
	margin-left: 15px;
}

.search {
	background: #fff;
	padding: 15px;
	border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
}

.search > label {
	font-weight: bold;
	font-size: 12px;
}

.search > input {
	width: 140px;
	margin-left: 15px;
}
</style>